import {
  SET_IS_LOADING,
  SET_SELF_SERVICE_USERS,
  CLEAR_SELF_SERVICE_USERS,
  SET_IS_SETTINGS_LOADING,
  SET_SELF_SERVICE_SETTINGS,
  CLEAR_SELF_SERVICE_SETTINGS
} from './constants';

export const setIsLoading = isLoading => ({
  type: SET_IS_LOADING,
  payload: isLoading
});

export const setSelfServiceUsers = data => ({
  type: SET_SELF_SERVICE_USERS,
  payload: data
});

export const clearSelfServiceUsers = () => ({
  type: CLEAR_SELF_SERVICE_USERS
});

export const setIsSettingsLoading = isLoading => ({
  type: SET_IS_SETTINGS_LOADING,
  payload: isLoading
});

export const setSelfServiceSettings = data => ({
  type: SET_SELF_SERVICE_SETTINGS,
  payload: data
});

export const clearSelfServiceSettings = () => ({
  type: CLEAR_SELF_SERVICE_SETTINGS
});